export default from './ResetPassword';



// WEBPACK FOOTER //
// ./src/components/ResetPassword/index.js